var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none",attrs:{"id":"whatsapp-button"}},[_c('a',{attrs:{"target":"_blank","href":"https://wa.me/55"}},[_c('img',{staticStyle:{"height":"60px"},attrs:{"src":require("@/assets/images/whatsapp.png")}})])])
}]

export { render, staticRenderFns }